// Player ids in spawn ring order (slot asc, id tie-break) — matches ServerGame / Room.startGame.
export function orderedSpawnIdsFromLobby(roster) {
  const list = [...(roster ?? [])].sort((a, b) => {
    const ds = (a.slot ?? 0) - (b.slot ?? 0)
    if (ds !== 0) return ds
    return String(a.id).localeCompare(String(b.id))
  })
  return list.map(p => p.id)
}

/*
 * Canvas rotation (rad): deathmatch only — each slot’s view is rotated so “toward arena
 * center” reads as screen-up (matches DeathMatchMode + ship rotation). Coop always 0.
 * World placement and heading come from the worker’s GameMode/DeathMatchMode spawns.
 */
export function computeShipOrientation(mode, ringIndex, playerCount) {
  if (playerCount <= 1) return 0
  if (String(mode ?? '').toLowerCase() !== 'deathmatch') return 0
  const n = playerCount
  const i = ((ringIndex % n) + n) % n
  const a = Math.PI / 2 + (i / n) * Math.PI * 2
  const ux = -Math.cos(a)
  const uy = -Math.sin(a)
  const len = Math.hypot(ux, uy) || 1
  const nux = ux / len
  const nuy = uy / len
  return -Math.PI / 2 - Math.atan2(nuy, nux)
}

// Ring index, ring size, orientation ({@link orderedSpawnIdsFromLobby}, {@link computeShipOrientation}).
export function spawnRing(roster, playerOrder, playerId, mode) {
  const rows = roster ?? []
  const sortedIds = orderedSpawnIdsFromLobby(rows)
  let ringIndex = sortedIds.findIndex(id => String(id) === String(playerId))
  if (ringIndex < 0 && playerOrder?.length > 0) {
    const j = playerOrder.findIndex(id => String(id) === String(playerId))
    if (j >= 0) ringIndex = j
  }
  if (ringIndex < 0) ringIndex = 0

  const ringSize = Math.max(
    1,
    sortedIds.length,
    playerOrder?.length ?? 0,
    rows.length,
    new Set(rows.map(p => p.id)).size,
    ringIndex + 1
  )
  return {
    ringIndex,
    ringSize,
    orientation: computeShipOrientation(mode, ringIndex, ringSize)
  }
}
